import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

const DeletePlanningCampaign = ({ campaignGroup, deletePlanningCampaign }) => {
  const [open, setOpen] = React.useState(false);

  console.log("campaignGroup", campaignGroup);

  const handleDelete = async () => {
    try {
      // Call the delete function passed as a prop
      await deletePlanningCampaign(campaignGroup.id);
      console.log("Campaign planning deleted successfully");
      setOpen(false);
    } catch (error) {
      console.error("Error deleting campaign planning:", error);
    }
  };

  return (
    <React.Fragment>
      <Button
        onClick={() => {
          setOpen(!open);
        }}
        color="error"
      >
        Delete campaign Planning
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Typography>Delete Campaign Planning</Typography>
          <Typography color="error" variant="body2" mt={1}>
            Are you sure you want to delete this campaign planning? This action
            cannot be undone.
          </Typography>

          <Typography variant="h5" color="textSecondary" mt={2}>
            Campaign Group: {campaignGroup?.name || "N/A"}
          </Typography>

          <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                // Add your delete logic here
                handleDelete();
                setOpen(false);
              }}
            >
              Delete
            </Button>

            <Button variant="outlined" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default DeletePlanningCampaign;
